import React from 'react'
import PreGameSnake from './preGameSnake'
import PreGameTetris from './preGameTetris'
import PreGameLinea3 from './preGameLinea3'
import './modalPreGame.scss'
import { useEffect } from 'react'
import pushPreGameMetric from './pushMetric'

const ModalPreGame = ({ onEnd, gametype }) => {
  const modal = {
    snake: <PreGameSnake onEnd={onEnd} />,
    tetris: <PreGameTetris onEnd={onEnd} />,
    linea3: <PreGameLinea3 onEnd={onEnd} />,
  }[gametype]

  useEffect(() => {
    pushPreGameMetric(
      gametype,
      'view',
      {
        snake: '¡Bienvenida al planeta menstruacion!',
        tetris: '¡Bienvenida al planeta pubertad!',
        linea3: '¡Bienvenida al planeta zona v!',
      }[gametype]
    )
  })
  return <div className={'f-modal-pre-game ' + ('--' + gametype)}>{modal}</div>
}

export default ModalPreGame
